import React from "react";

import { Grid } from "@mui/material";
import { ContainerCardMaterial } from "components/haven-design";

const ContainerWithSidebar: React.FC<{children: React.ReactNodeArray}> = ({ children }) => (
  <ContainerCardMaterial>
    <Grid size={{ xs: 12, md: 3 }}>
      {children ? children[0] : ""}
    </Grid>
    <Grid size={{ xs: 12, md: 9 }}>
      {children ? children[1] : ""}
    </Grid>
  </ContainerCardMaterial>
);

export default ContainerWithSidebar;
